jQuery('.gallery-slider').slick({
    arrows: true,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: "<div class='slick-prev pull-left'></div>",
    nextArrow: "<div class='slick-next pull-right'></div>",
    draggable: false,
});

jQuery('.homepage-slider').slick({
    arrows: true,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: "<div class='slick-prev pull-left'></div>",
    nextArrow: "<div class='slick-next pull-right'></div>",
    draggable: false,
});

jQuery('.news-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    draggable: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
    ]
});

jQuery('.homepage-news-slider').slick({
    arrows: true,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    draggable: false,
    prevArrow: "<div class='slick-prev pull-left'></div>",
    nextArrow: "<div class='slick-next pull-right'></div>",
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
    ]
});